/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createHook } from '../../core/factories/createHook.js';

import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetImagesQuotaRow } from '../openapi-types.gen.js';
import { type useGetImagesQuotaArgs, useGetImagesQuotaSpec } from '../specs/images.spec.gen.js';

export type { GetImagesQuotaRow } from '../openapi-types.gen.js';
export type { useGetImagesQuotaArgs } from '../specs/images.spec.gen.js';


export const useGetImagesQuota = createHook(useGetImagesQuotaSpec);


/**
 * Hover/intent prefetch companion for `useGetImagesQuota`. Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * and writes the response into the SAME cache entry the reader hook
 * observes. The component owning the callback does NOT subscribe — no
 * re-renders on data, no NATS subscription. Idempotent: TanStack
 * `prefetchQuery` is a no-op when a fresh cache entry already exists.
 *
 *     function Link({ pubkey }) {
 *       const prefetch = usePrefetchGetImagesQuota();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({ pubkey })}
 *           onFocus={() => prefetch({ pubkey })}
 *         >…</a>
 *       );
 *     }
 */
export const usePrefetchGetImagesQuota = createPrefetchHook(useGetImagesQuotaSpec);
